import {v4 as uuidv4} from 'uuid';
import {head} from 'lodash-es';
import type {ToastNotification} from '~/types/toastNotification';

export const useToastNotificationStore = defineStore('toastNotification', () => {
	const toastNotificationSet = ref<Set<ToastNotification>>(new Set());
	const toastNotificationStack = computed(() => Array.from(toastNotificationSet.value));
	const activeToastNotification = computed<ToastNotification | null>(() => head(toastNotificationStack.value) ?? null);

	function addToastNotification(notification: Omit<ToastNotification, 'id'>) {
		const notificationWithId = {
			...notification,
			id: uuidv4(),
		};
		toastNotificationSet.value.add(notificationWithId);
	}

	function removeToastNotification(notification: ToastNotification) {
		toastNotificationSet.value.delete(notification);
	}

	return {
		addToastNotification,
		removeToastNotification,
		toastNotificationStack,
		activeToastNotification,
	};
});
